/* this file is transformed by vux-loader */
/* eslint-disable */
/* this file is transformed by vux-loader */

/* eslint-disable */
import Vue from 'vue';
import Router from 'vue-router';
import Home from '@/page/Home/index.vue';
import LiveTrailer from '@/page/Live/List/index.vue';
import LiveDetail from '@/page/NewLiving/index.vue';
import LivingShareCard from '@/page/NewLiving/livingShareCard.vue';
import ZoneList from '@/page/Zone/list/index.vue';
import Universally from '@/page/Zone/Detail/Universally/index.vue';
import FacingEachOther from '@/page/FacingEachOther/index';
import Special from '@/page/FacingEachOther/Special/index.vue';
import CourseList from '@/page/Course/List/index';
import CourseDetail from '@/page/Course/Detail/index';
import HeadlineDetail from '@/page/Headlines/Detail/index';
import HeadlineList from '@/page/Headlines/List/index';
import Search from '@/page/Search/index';
import Personal from '@/page/Personal/index';
import Collection from '@/page/Personal/Collection/index.vue';
import Record from '@/page/Personal/Record/index.vue';
import Register from '@/page/Register/index.vue';
import SignIn from '@/page/SignIn/index.vue';
import Perfect from '@/page/perfect/index.vue';
import HeadlineShare from '@/page/Share/headLineShare.vue';
import LiveShare from '@/page/Share/liveShare.vue';
import CourseShare from '@/page/Share/courseShare.vue';
import PersonalSwitch from '@/page/Personal/Switch/index.vue';
import SpecialList from '@/page/FacingEachOther/specialList/index.vue';
import SpecialTopic from '@/page/SpecialTopic/index.vue';
import MedicalToday from '@/page/MedicalCircleToday/index.vue';
import WeekendCourse from '@/page/WeekendCourse/index.vue';
import Survey from '@/page/Survey/index.vue';
import PersonalLogOffApply from '@/page/Personal/LogOff/Apply.vue';
import PersonalLogOffConfirm from '@/page/Personal/LogOff/Confirm.vue';
import PersonalLogOffAgreement from '@/page/Personal/LogOff/Agreement.vue';

var _import = require('./_import_production'); // import Login from "@/page/login/index.vue"


Vue.use(Router);
export default new Router({
  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    return savedPosition || {
      x: 0,
      y: 0
    };
  },
  routes: [{
    path: '/',
    redirect: '/home'
  }, {
    path: '/home',
    name: 'home',
    component: Home,
    meta: {
      title: '医学V视界',
      pageName: '首页'
    }
  }, {
    path: '/register',
    name: 'register',
    component: Register,
    meta: {
      title: '注册/登录',
      pageName: '注册页'
    }
  }, {
    path: '/personal',
    name: 'personal',
    component: Personal,
    meta: {
      title: '个人中心',
      newUserEntry: true,
      pageName: '个人中心页'
    }
  }, {
    path: '/personalSwitch',
    name: 'personalSwitch',
    component: PersonalSwitch,
    meta: {
      title: '个人中心',
      newUserEntry: true,
      pageName: '任务提醒设置页'
    }
  }, {
    path: '/personalSwitch',
    name: 'personalSwitch',
    component: PersonalSwitch,
    meta: {
      title: '个人中心',
      newUserEntry: true,
      pageName: '任务提醒设置页'
    }
  }, {
    path: '/PersonalLogOffApply',
    name: 'PersonalLogOffApply',
    component: PersonalLogOffApply,
    meta: {
      title: '账号注销',
      newUserEntry: true,
      pageName: '账号注销'
    }
  }, {
    path: '/PersonalLogOffConfirm',
    name: 'PersonalLogOffConfirm',
    component: PersonalLogOffConfirm,
    meta: {
      title: '确认注销',
      newUserEntry: true,
      pageName: '确认注销'
    }
  }, {
    path: '/PersonalLogOffAgreement',
    name: 'PersonalLogOffAgreement',
    component: PersonalLogOffAgreement,
    meta: {
      title: '账号注销协议',
      newUserEntry: true,
      pageName: '账号注销协议'
    }
  }, {
    path: '/collection',
    name: 'collection',
    component: Collection,
    meta: {
      title: '我的收藏',
      newUserEntry: true,
      pageName: '我的收藏页'
    }
  }, {
    path: '/record',
    name: 'record',
    component: Record,
    meta: {
      title: '听课记录',
      newUserEntry: true,
      pageName: '听课记录页'
    }
  }, {
    path: '/search',
    name: 'search',
    component: Search,
    meta: {
      title: '搜索',
      pageName: '搜索页'
    }
  }, {
    path: '/courseList',
    name: 'courseList',
    component: CourseList,
    meta: {
      title: '医学微课堂',
      pageName: '课程列表页'
    }
  }, {
    path: '/courseDetail/:id',
    name: 'courseDetail',
    component: CourseDetail,
    meta: {
      title: '课程详情',
      newUserEntry: true,
      pageName: '课程详情页'
    }
  }, {
    path: '/courseShare/:id',
    name: 'courseShare',
    component: CourseShare,
    meta: {
      title: '课程详情',
      newUserEntry: true,
      pageName: '课程分享落地页'
    }
  }, {
    path: '/liveDetail/:id',
    name: 'liveDetail',
    component: LiveDetail,
    meta: {
      title: '直播详情',
      newUserEntry: true,
      pageName: '直播详情页'
    }
  }, {
    path: '/liveShare/:id',
    name: 'liveShare',
    component: LiveShare,
    meta: {
      title: '直播详情',
      newUserEntry: true,
      pageName: '直播分享落地页'
    }
  }, {
    path: '/livingShareCard/:id',
    name: 'livingShareCard',
    component: LivingShareCard,
    meta: {
      title: '直播详情',
      newUserEntry: true,
      pageName: '直播分享落地页'
    }
  }, {
    path: '/headlineList',
    name: 'headlineList',
    component: HeadlineList,
    meta: {
      title: '医学V视界',
      pageName: '头条列表页',
      keepAlive: true
    }
  }, {
    path: '/argotList',
    name: 'argotList',
    component: _import('/Headlines/List/', 'argotList.vue'),
    meta: {
      title: '暗语红包列表',
      pageName: '暗语红包列表'
    }
  }, {
    path: '/headlineShare/:id',
    name: 'headLineShare',
    component: HeadlineShare,
    meta: {
      title: '头条',
      pageName: '资讯分享落地页'
    }
  }, {
    path: '/headlineDetail/:id',
    name: 'headlineDetail',
    component: HeadlineDetail,
    meta: {
      title: '头条详情',
      newUserEntry: true,
      pageName: '头条详情页'
    }
  }, {
    path: '/zoneList',
    name: 'zoneList',
    component: ZoneList,
    meta: {
      title: '学术专区',
      pageName: '专区列表页'
    }
  }, {
    path: '/universally/:id',
    name: 'universally',
    component: Universally,
    meta: {
      title: '专区详情',
      newUserEntry: true,
      pageName: '专区详情页'
    }
  }, {
    path: '/signIn/:id',
    name: 'signIn',
    component: SignIn,
    meta: {
      title: '签到',
      newUserEntry: true,
      pageName: '课程签到页'
    }
  }, {
    path: '/facingEachOther',
    name: 'facingEachOther',
    component: FacingEachOther,
    meta: {
      title: '专家访谈',
      pageName: '超级面对面列表页'
    }
  }, {
    path: '/special/:id',
    name: 'special',
    component: Special,
    meta: {
      title: '超级面对面',
      pageName: '超级面对面详情页'
    }
  }, {
    path: '/liveTrailer',
    name: 'liveTrailer',
    component: LiveTrailer,
    meta: {
      title: '更多直播',
      pageName: '直播、预告列表页'
    }
  }, {
    path: '/medicalToday',
    name: 'medicalToday',
    component: MedicalToday,
    meta: {
      title: '今日医疗圈',
      pageName: '今日医疗圈页'
    }
  }, // WeekendCourse
  // 暂时不用
  {
    path: '/weekendCourse',
    name: 'weekendCourse',
    component: WeekendCourse,
    meta: {
      title: '课程精选',
      pageName: '课程精选页'
    }
  }, {
    path: '/perfect',
    name: 'perfect',
    component: Perfect,
    meta: {
      title: '完善信息',
      newUserEntry: true,
      pageName: '完善信息页'
    }
  }, {
    path: '/specialList',
    name: 'specialList',
    component: SpecialList,
    meta: {
      title: '超级面对面',
      pageName: '超级面对面列表'
    }
  }, {
    path: '/specialTopic/:id',
    name: 'specialTopic',
    component: _import('/SpecialTopic'),
    meta: {
      title: '专题-资讯合集7月',
      pageName: '专题合辑页'
    }
  }, {
    path: '/blTopic/:id',
    name: 'blTopic',
    component: _import('/Headlines/List', '/blTopic'),
    meta: {
      title: '病例',
      pageName: '病例-话题'
    }
  }, {
    path: '/task',
    name: 'task',
    component: _import('/Task'),
    meta: {
      title: '每日任务',
      pageName: '每日任务页'
    }
  }, {
    path: '/pushTempAns',
    name: 'pushTempAns',
    component: _import('/pushTemplate', '/answer'),
    meta: {
      title: '答题推送',
      pageName: '答题推送页'
    }
  }, {
    path: '/survey/:id',
    name: 'survey',
    component: Survey,
    meta: {
      title: '调研问卷',
      pageName: '调研问卷'
    },
    props: function props(r) {
      return {
        questionnaireId: parseInt(r.params.id)
      };
    }
  }]
});